import styled from 'styled-components';
import Text from './Text';
import { colors } from '@10d/tend-ui-tokens/samolet';

const Required = styled(Text)`
  &:after {
    content: '*';
    padding-left: 3px;
    color: ${colors.red600};
  }
`;

export default Required;
